export const CREATE_VENTE = "CREATE_VENTE";
export const RETRIEVE_VENTES = "RETRIEVE_VENTES";
export const UPDATE_VENTE = "UPDATE_VENTE";
export const DELETE_VENTE = "DELETE_VENTE";
export const DELETE_ALL_VENTES = "DELETE_ALL_VENTES";

